import store from '@/store'
class Win {
    /*
     * 通用弹窗函数
     */
    openModal(componment,width=1000,height=800,title='',data={},fullscreen=false,closeJudge=false){
        store.commit('modalConfig',
            {
                'width':width,
                'height':height,
                'title':title,
                'data':data,
                'componment':componment,
                'fullscreen':fullscreen,
                'closeJudge':closeJudge
            });
    }
    closeWin(){

    }
    closeModal(){
        store.commit('modalClose');
    }
}

export default  new Win()
